import { z } from 'zod';
import donnees from './donnees/premier-contact.v1.json' with { type: 'json' };

/**
 * « Qui est venu vous voir ? » (décision de Joel, 26/10/2026) : question posée au premier contact, à la création du dossier.
 * La question et ses choix sont la donnée versionnée `donnees/premier-contact.v1.json` (ajouter un choix = changer la donnée).
 * La réponse est gardée sur le dossier et n'est rendue qu'à l'équipe MAAT.
 */
export interface ReferentielPremierContact {
  version: string;
  statut: string;
  source: string;
  question: string;
  options: readonly { code: string; libelle: string }[];
}

export const PREMIER_CONTACT: ReferentielPremierContact = donnees;

const codes = PREMIER_CONTACT.options.map((o) => o.code) as [string, ...string[]];

export const VenuParSchema = z
  .enum(codes)
  .meta({ id: 'VenuPar', description: 'Réponse à « Qui est venu vous voir ? » (code de la donnée versionnée).' });

export const libelleVenuPar = (code: string): string | null => PREMIER_CONTACT.options.find((o) => o.code === code)?.libelle ?? null;
